import { Box, ListItem } from "@mui/material"
import { PropertyBox } from "lib/@components/property-box"
import { Frag } from "lib/@components/slot/frag"

export function DifferenceWrapper({ children, wrapper = <Frag /> }) {
    return (
        <Box overflow="hidden" pl={2} className="difference">
            <wrapper.type {...wrapper.props}>
                <ListItem>
                    <PropertyBox>{children}</PropertyBox>
                </ListItem>
            </wrapper.type>
        </Box>
    )
}
